export const QUERY_USER_FAV_FUNC_KEY = '/v1/userFavFunc/queryUserFavFunc';
